import type { SortOrder, SupplierDirectorySortField } from '@tandemone/types'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { listPublicSuppliers, listSuppliers } from './api'

export const SUPPLIERS_DEFAULT_PAGE_SIZE = 10

export type UseSuppliersOptions = {
  founding: boolean
  verified: boolean
  favorites: boolean
  search?: string
  countries: string[]
  capabilityGroups: string[]
  industries: string[]
  certifications: string[]
  page: number
  pageSize?: number
  sort?: SupplierDirectorySortField
  order?: SortOrder
  audience?: 'member' | 'public'
}

export function useSuppliers(opts: UseSuppliersOptions) {
  const pageSize = opts.pageSize ?? SUPPLIERS_DEFAULT_PAGE_SIZE
  const search = opts.search?.trim() || undefined
  const params = {
    founding: opts.founding,
    verified: opts.verified,
    favorites: opts.favorites,
    search,
    countries: opts.countries,
    capabilityGroups: opts.capabilityGroups,
    industries: opts.industries,
    certifications: opts.certifications,
    page: opts.page,
    pageSize,
    sort: opts.sort,
    order: opts.order
  }
  const isPublic = opts.audience === 'public'
  return useQuery({
    queryKey: [
      isPublic ? 'supplier-network' : 'supplier-directory',
      'list',
      params
    ],
    queryFn: ({ signal }) =>
      isPublic
        ? listPublicSuppliers(params, signal)
        : listSuppliers(params, signal),
    placeholderData: keepPreviousData,
    staleTime: 30_000
  })
}
